import * as React from 'react';
import { Textarea } from '@/components/forms/ui/textarea';

type TextareaFieldProps = {
  id: string;
  label: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  onBlur?: () => void;
  placeholder?: string;
  description?: string;
  error?: string;
  rows?: number;
};

export function TextareaField({
  id,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  description,
  error,
  rows = 3
}: TextareaFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium">
        {label}
      </label>
      <Textarea
        id={id}
        value={value ?? ''}
        rows={rows}
        placeholder={placeholder}
        className="resize-none"
        onChange={e => onChange(e.target.value === '' ? undefined : e.target.value)}
        onBlur={onBlur}
        aria-invalid={error ? true : undefined}
      />
      {description ? <span className="text-muted-foreground text-sm">{description}</span> : null}
      {error ? <span className="text-destructive text-sm">{error}</span> : null}
    </div>
  );
}
